import { fixedUi } from '@/i18n/fixedUi';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import CategoryCascader from '@/tiktok-platform/components/CategoryCascader';
import {
  applyCategoryDisplayLang,
  resolveCategoryDisplayLang,
} from '@/tiktok-platform/utils/tiktokCategoryDisplayLang';

/**
 * 店铺可发类目：后端已按 is_leaf=true 且 AVAILABLE 裁剪成树；
 * 展示名跟随全局 i18n（中文用 nameZh，其它语言用 nameEn）。
 */
export default function ShopCategoryPanel({
  loading,
  error,
  categories,
}) {
  const { i18n } = useTranslation();
  const lang = useMemo(
    () => resolveCategoryDisplayLang(i18n.resolvedLanguage || i18n.language),
    [i18n.resolvedLanguage, i18n.language],
  );

  const displayCategories = useMemo(
    () => applyCategoryDisplayLang(categories, lang),
    [categories, lang],
  );

  return (
    <div className="tko-shop-info__panel" data-testid="tiktok-category-tree">
      <div className="tko-shop-info__category-head">
        <h2 className="tko-return-detail__section-title tko-shop-info__category-title">{fixedUi("可发类目")}</h2>
      </div>

      {loading ? <p className="tko-return-detail__empty">{fixedUi("正在查询可发类目…")}</p> : null}
      {error ? <p className="tko-shop-info__inline-error" role="alert">{error}</p> : null}

      {!loading && !error ? (
        <div className="tko-shop-info__category-body">
          {!Array.isArray(categories) || categories.length === 0 ? (
            <p className="tko-return-detail__empty">
              {fixedUi("暂无可发类目缓存。请点击「拉取 TikTok 后台数据」从平台拉取。")}
            </p>
          ) : (
            <CategoryCascader
              key={lang}
              categories={displayCategories}
              hideDetail={false}
            />
          )}
        </div>
      ) : null}
    </div>
  );
}
